import { Lobby } from '@/views/Lobby'
import Account from '@/views/Lobby/Account'
import Draft from '@/views/Lobby/Draft'
import SignIn from '@/views/SignIn'
import SignUp from '@/views/SignUp'
import SignOut from '@/views/SignOut'
import ForgotPassword from '@/views/SignInForgot'
import SignUpConfirm from '@/views/SignUpConfirm'
import Page404 from '@/views/Page404'
import Home from '@/views/Home'
import DraftHistory from '@/views/Lobby/DraftHistory'
import DraftHistoryDetail from '@/views/Lobby/DraftHistoryDetail'
import { IDraft } from '@/store/modules/draft/interfaces'
import Withdrawal from '@/views/Lobby/Withdrawal'
import Wallet from '@/views/Lobby/Wallet'
import AddFunds from '@/views/Lobby/AddFunds'
import { VirtualLobby } from '@/views/Lobby/Virtual'

export default [
  {
    path: '/home', name: 'home', component: Home,
    meta: { 
      group: 'home', title: 'Home', auth: true
    }
  },
  {
    path: '/signout', name: 'signOut', component: SignOut,
    meta: { 
      title: 'SignOut', auth: false
    }
  },
  {
    path: '/lobby', name: 'lobby', component: Lobby,
    meta: { 
      title: 'Lobby', auth: true
    }
  },
  {
    path: '/virtual', name: 'virtual', component: VirtualLobby,
    meta: { 
      title: 'Virtual', auth: true
    }
  },
  {
    path: '/draft', name: 'draft', component: Draft,
    meta: { 
      group: 'draft', title: 'Ticket', auth: true
    }
  },
  {
    path: '/draft/:chunk/:id', name: 'draftDetail', component: DraftHistoryDetail,
    meta: { 
      group: 'account', title: 'Ticket Detail', auth: true
    }
  },
  {
    path: '/drafthistory', name: 'draftHistory', component: DraftHistory,
    meta: { 
      group: 'account', title: 'Ticket History', auth: true
    }
  },
  {
    path: '/account', name: 'account', component: Account,
    meta: { 
      group: 'account', title: 'Account', auth: true
    }
  },
  {
    path: '/addfunds', name: 'addfunds', component: AddFunds,
    meta: { 
      group: 'account', title: 'Add Funds', auth: true
    }
  },
  {
    path: '/withdrawal', name: 'withdrawal', component: Withdrawal,
    meta: { 
      group: 'account', title: 'Request Withrawal', auth: true
    }
  },
  {
    path: '/wallet', name: 'wallet', component: Wallet,
    meta: { 
      group: 'account', title: 'Payment History', auth: true
    }
  },
  {
    path: '/signin', name: 'signIn', component: SignIn, 
    props: {
      class: 'qpAuthenticator',
      id: 'qpAuthenticatorSignIn' // arbitrary class name
    },
    meta: { 
      title: 'Sign In', auth: false
    }
  },
  {
    path: '/forgot', name: 'forgot', component: ForgotPassword, 
    props: {
      class: 'qpAuthenticator',
      id: 'qpAuthenticatorForgot' // arbitrary class name
    },
    meta: { 
      title: 'Forgotten Password', auth: false
    }
  },
  {
    path: '/signup', name: 'signUp', component: SignUp,
    props: {
      class: 'qpAuthenticator',
      id: 'qpAuthenticatorSignUp' // arbitrary class name
    },
    meta: { 
      title: 'Sign Up', auth: false
    }
  },
  {
    path: '/verify', name: 'signUpConfirm', component: SignUpConfirm,
    props: {
      class: 'qpAuthenticator',
      id: 'qpAuthenticatorSignUpConfirm' // arbitrary class name
    },
    meta: { 
      title: 'Verify Account', auth: false
    }
  },
  {
    path: '/404', name: '404', component: Page404,
    meta: {
      auth: false,
    },
  },
  {
    path: '/', redirect: '/signin',
  },
  {
    path: '/*', redirect: '/404',
  },
];
